var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unindented-body"},[_c('div',{staticClass:"dividing-line mt-0 mb-5"})])}]

export { render, staticRenderFns }